module.exports = __webpack_public_path__ + "static/media/reviewSelected.1f9efb46.svg";